import { useEffect, useState } from "react";
import { FirestoreService } from "../../../api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../api/firebase/references";
import { DraftSubmission } from "../../../data-model/draftSubmission";

interface UseDraftSubmissionReturn {
  draftSubmission: DraftSubmission[] | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useDraftSubmission = (
  orderId: string | undefined,
): UseDraftSubmissionReturn => {
  const [draftSubmission, setDraftSubmission] = useState<
    DraftSubmission[] | null
  >(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const getDraftSubmission = async (id: string) => {
    try {
      setLoading(true);
      setError(null);
      const result = await FirestoreService.getAllDocuments(
        FirestoreCollectionReference.draftSubmission(id),
      );
      setDraftSubmission(result as DraftSubmission[]);
    } catch (err) {
      setError(
        err instanceof Error ? err.message : "Failed to fetch draft submission",
      );
      console.error("Error fetching draft submission:", err);
    } finally {
      setLoading(false);
    }
  };

  const refetch = () => {
    if (orderId) {
      getDraftSubmission(orderId);
    }
  };

  useEffect(() => {
    if (orderId) {
      getDraftSubmission(orderId);
    }
  }, [orderId]);

  return {
    draftSubmission,
    loading,
    error,
    refetch,
  };
};
